/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const CirclePencilSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#CAC8C8" />
    <path
      d="M11.5664 5.9741C11.7003 5.84016 11.7003 5.57228 11.5664 5.37136L10.5618 4.43377C10.4279 4.29983 10.16 4.29983 9.95907 4.43377L9.28936 5.17045L10.8297 6.71079L11.5664 5.9741ZM4.3335 10.1263V11.6666H5.87383L10.3609 7.11261L8.82056 5.57228L4.3335 10.1263Z"
      fill="white"
    />
  </svg>
)
const CirclePencilDisabledSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="8"
      cy="8"
      r="7.8"
      fill="#F9F9F9"
      stroke="#C4C4C4"
      strokeWidth="0.4"
    />
    <path
      d="M12.8498 4.91779L11.1322 3.2002L4.26187 10.0706L3.57483 12.4752L5.97946 11.7882L12.8498 4.91779Z"
      fill="#C4C4C4"
    />
    <path
      d="M4.26187 10.0706L11.1322 3.2002L12.8498 4.91779L5.97946 11.7882M4.26187 10.0706L3.57483 12.4752L5.97946 11.7882M4.26187 10.0706L5.97946 11.7882M9.75816 4.57427L11.4758 6.29186"
      stroke="#F9F9F9"
      strokeWidth="0.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CirclePencilIcon = (props) => {
  if (props.disabled) {
    return <Icon component={CirclePencilDisabledSvg} {...props} />
  }
  return <Icon component={CirclePencilSvg} {...props} />
}

export { CirclePencilIcon }
